import React from 'react';
import PropTypes from 'prop-types';
import {ChannelLineup} from 'src/pages/localChannelLineup/components/ChannelLineup';
import {ChannelsLoading} from 'src/pages/localChannelLineup/components/ChannelsLoading';
import {AddressInput} from 'src/pages/localChannelLineup/components/AddressInput';
import Xfinity from 'src/svgs/XfinitySmall.svg';
import {linkButton} from 'src/styles/modules/linkButton.module.scss';
import {mainWide} from 'src/styles/modules/main.module.scss';
import {ASC, DESC} from 'src/pages/localChannelLineup/constants/lineupOrder';

export const Page = ({
  address,
  channels,
  channelsLoading,
  channelsLoaded,
  channelsError,
  clearLocationSuggestions,
  filter,
  firstName,
  isAuthenticated,
  lineupOrder,
  loadChannels,
  loadLocationSuggestions,
  print,
  setAddress,
  setFilter,
  setLineupOrder,
  showFirstName,
  signInUrl,
  suggestions,
}) =>
  <main className={mainWide}>
    {
      (channelsLoading)
        ? <ChannelsLoading />
        : (
          <>
            <header>
              <span>
                <h1>
                  {isAuthenticated
                    ? 'What are you going to watch next?'
                    : 'Browse channels available in your area'
                  }
                </h1>
                {channels.length > 0 && <button onClick={print} className={linkButton}>Print</button>}
              </span>
              {
                channelsLoaded
                && channels.length >= 0
                && isAuthenticated
                && <p>{`${showFirstName && firstName ? firstName + '’s' : 'Your'} channel lineup looks great!`}</p>
              }
            </header>
            <Xfinity className="printOnly" />
            <AddressInput
              address={address}
              channelsLoaded={channelsLoaded}
              clearLocationSuggestions={clearLocationSuggestions}
              filter={filter}
              lineupOrder={lineupOrder}
              loadChannels={loadChannels}
              loadLocationSuggestions={loadLocationSuggestions}
              setAddress={setAddress}
              setFilter={setFilter}
              setLineupOrder={setLineupOrder}
              suggestions={suggestions}
              signInUrl={signInUrl}
              isAuth={isAuthenticated}
            />
            <section>
              {(channelsLoaded || channelsError) &&
                <ChannelLineup
                  channels={channels}
                  channelsError={channelsError}
                  filter={filter}
                  lineupOrder={lineupOrder}
                />
              }
            </section>
          </>
        )
    }
  </main>;

Page.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.shape({
    channelNumber: PropTypes.number,
    channelName: PropTypes.string,
    logoUrl: PropTypes.string,
  })),
  address: PropTypes.string.isRequired,
  channelsError: PropTypes.bool.isRequired,
  channelsLoading: PropTypes.bool.isRequired,
  channelsLoaded: PropTypes.bool.isRequired,
  clearLocationSuggestions: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  lineupOrder: PropTypes.oneOf([ASC, DESC]).isRequired,
  loadChannels: PropTypes.func.isRequired,
  loadLocationSuggestions: PropTypes.func.isRequired,
  print: PropTypes.func.isRequired,
  setAddress: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setLineupOrder: PropTypes.func.isRequired,
  showFirstName: PropTypes.bool.isRequired,
  signInUrl: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
};
